export default "__VITE_ASSET__Bz91t7oH__"